/* Doubleback Live Agent — storefront widget + AI chat client.
 * Header: red breathing Live Agent w/ visitor country · state temp · date · live time.
 * Click → clean chat panel (~1/3 screen). No dependencies. */
(function () {
  'use strict';

  var ENDPOINT = String(window.LIVE_AGENT_ENDPOINT || '').replace(/\/+$/, '');
  var API_URL = ENDPOINT ? ENDPOINT + '/chat' : '';
  var GREETING = window.LIVE_AGENT_GREETING || "Hi, I'm Sara — Doubleback's online store manager. Ask me anything about fits, styling, shipping, or what's new in the collection.";

  var openBtn = document.getElementById('liveAgent');
  var chat = document.getElementById('laChat');
  var closeBtn = document.getElementById('laClose');
  var msgs = document.getElementById('laMsgs');
  var chips = document.getElementById('laChips');
  var form = document.getElementById('laForm');
  var input = document.getElementById('laInput');
  var sendBtn = document.getElementById('laSend');
  if (!openBtn || !chat) return;

  var history = [];
  var busy = false;
  var firstOpen = true;
  function isMobileChat() {
    return window.matchMedia && window.matchMedia('(max-width: 560px)').matches;
  }

  /* Persist the conversation so it survives navigation between pages
     (sessionStorage = same tab; cleared when the tab closes). */
  var STORE_KEY = 'dbb_la_conv_v1';
  function saveState() {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({
        history: history.slice(-40),
        open: chat.classList.contains('open')
      }));
    } catch (e) {}
  }
  function loadState() {
    try {
      var s = sessionStorage.getItem(STORE_KEY);
      return s ? JSON.parse(s) : null;
    } catch (e) { return null; }
  }
  // Restore the conversation from the previous page load
  (function restore() {
    var saved = loadState();
    if (!saved || !saved.history || !saved.history.length) return;
    history = saved.history.slice(-40);
    firstOpen = false; // don't re-greet; resume the existing thread
    history.forEach(function (m) {
      if (m.role === 'user') bubble('user', linkify(m.content));
      else if (m.role === 'assistant') bubble('agent', linkify(m.content));
    });
    msgs.scrollTop = msgs.scrollHeight;
    if (saved.open) {
      chat.classList.add('open');
      chat.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
    }
  })();

  /* ── Header: geo + weather + live clock ─────────────────────────── */
  function fmtLoc() {
    var geo = document.querySelector('[data-la-geo]');
    var clock = document.querySelector('[data-la-clock]');
    var tz = null;
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone; } catch (e) {}

    fetch('https://ipwho.is/')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.success) throw new Error('geo fail');
        tz = d.timezone && d.timezone.id ? d.timezone.id : tz;
        var cc = (d.country_code || '').toUpperCase();
        var region = d.region || d.city || '';
        if (geo && cc) {
          geo.textContent = cc + (region ? ' \u00B7 ' + region.toUpperCase() : '');
          geo.setAttribute('title', (d.city || '') + ', ' + (d.country || ''));
        }
        // weather
        if (d.latitude && d.longitude) {
          var isUS = cc === 'US';
          fetch('https://api.open-meteo.com/v1/forecast?latitude=' + d.latitude + '&longitude=' + d.longitude +
            '&current_weather=true&temperature_unit=' + (isUS ? 'fahrenheit' : 'celsius'))
            .then(function (r) { return r.json(); })
            .then(function (w) {
              var t = w && w.current_weather && w.current_weather.temperature;
              if (geo && typeof t === 'number') {
                geo.textContent = cc + ' \u00B7 ' + (region ? region.toUpperCase() + ' \u00B7 ' : '') + Math.round(t) + '\u00B0';
              }
            })
            .catch(function () {});
        }
        // clock
        if (clock && tz) {
          var fmtDate = new Intl.DateTimeFormat('en-GB', { timeZone: tz, day: '2-digit', month: 'short' });
          var fmtTime = new Intl.DateTimeFormat('en-GB', { timeZone: tz, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
          function tick() {
            var now = new Date();
            clock.textContent = fmtDate.format(now).replace(/ /g, ' ').toUpperCase() + ' \u00B7 ' + fmtTime.format(now);
          }
          tick();
          setInterval(tick, 1000);
        }
      })
      .catch(function () {
        // offline fallback: local clock only
        if (clock) {
          var f = new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
          function tick2() { clock.textContent = f.format(new Date()).replace(/ /g, ' ').toUpperCase(); }
          tick2();
          setInterval(tick2, 1000);
        }
      });
  }
  fmtLoc();

  /* ── Chat UI ────────────────────────────────────────────────────── */
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }
  function linkify(text) {
    // product links → clickable; keep **bold**
    var bold = esc(text).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    return bold.replace(/(https?:\/\/[^\s]+)/g, function (u) {
      return '<a href="' + u + '" target="_blank" rel="noopener">' + u.replace(/^https?:\/\//, '') + '</a>';
    });
  }
  function bubble(role, html) {
    var d = document.createElement('div');
    d.className = 'la-msg la-msg--' + role;
    d.innerHTML = html;
    msgs.appendChild(d);
    msgs.scrollTop = msgs.scrollHeight;
    return d;
  }
  function typing() {
    var d = document.createElement('div');
    d.className = 'la-msg la-msg--agent la-typing';
    d.innerHTML = '<span></span><span></span><span></span>';
    msgs.appendChild(d);
    msgs.scrollTop = msgs.scrollHeight;
    return d;
  }
  function chip(label, q) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'la-chip';
    b.textContent = label;
    b.addEventListener('click', function () { ask(q); });
    chips.appendChild(b);
  }
  function renderOptions(opts) {
    chips.innerHTML = '';
    if (!opts || !opts.length) return;
    opts.forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'la-opt';
      b.textContent = o;
      b.addEventListener('click', function () { ask(o); });
      chips.appendChild(b);
    });
  }
  function renderProducts(products) {
    if (!products || !products.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'la-prods';
    var preview = window.location.search || ''; // keep ?preview_theme_id=…
    products.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'la-prod';
      a.href = '/products/' + encodeURIComponent(p.handle) + preview;
      if (p.img) {
        var im = document.createElement('img');
        im.src = (p.img.indexOf('//') === 0 ? 'https:' : '') + p.img;
        im.alt = p.title || '';
        im.loading = 'lazy';
        a.appendChild(im);
      }
      var info = document.createElement('div');
      info.className = 'la-prod__info';
      var n = document.createElement('div');
      n.className = 'la-prod__name';
      n.textContent = p.title || '';
      info.appendChild(n);
      if (typeof p.price === 'number') {
        var pr = document.createElement('div');
        pr.className = 'la-prod__price';
        pr.textContent = 'RM' + (Number.isInteger(p.price) ? p.price : p.price.toFixed(2));
        info.appendChild(pr);
      }
      a.appendChild(info);
      wrap.appendChild(a);
    });
    msgs.appendChild(wrap);
    msgs.scrollTop = msgs.scrollHeight;
  }

  var CHIPS = [
    ['What\u2019s new this week?', 'What are the newest pieces this week?'],
    ['Help me find a fit', 'I need help choosing my size — I\u2019m 175cm and 70kg, regular fit'],
    ['Oversized tees', 'Show me your oversized t-shirts'],
    ['Free shipping?', 'What are your shipping options to Singapore?']
  ];

  function openChat() {
    chat.classList.add('open');
    document.body.classList.add('la-chat-open');
    chat.setAttribute('aria-hidden', 'false');
    openBtn.setAttribute('aria-expanded', 'true');
    if (firstOpen) {
      firstOpen = false;
      bubble('agent', linkify(GREETING));
      history.push({ role: 'assistant', content: GREETING });
      if (ENDPOINT) {
        CHIPS.forEach(function (c) { chip(c[0], c[1]); });
      } else {
        bubble('agent', 'The agent is being connected. Please check back shortly.');
      }
      saveState();
    }
    if (!isMobileChat()) input.focus();
  }
  function closeChat() {
    chat.classList.remove('open');
    chat.classList.remove('keyboard-up');
    document.body.classList.remove('la-chat-open', 'la-keyboard-open');
    document.documentElement.style.removeProperty('--la-vh');
    document.documentElement.style.removeProperty('--la-kb');
    chat.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    if (document.activeElement === input) input.blur();
    saveState();
  }

  openBtn.addEventListener('click', function () {
    if (chat.classList.contains('open')) closeChat(); else openChat();
  });
  closeBtn.addEventListener('click', closeChat);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && chat.classList.contains('open')) closeChat(); });
  chat.addEventListener('click', function (e) { if (e.target === chat) closeChat(); });

  function ask(q) {
    q = String(q || '').trim();
    if (!q || busy) return;
    bubble('user', linkify(q));
    history.push({ role: 'user', content: q });
    saveState();
    input.value = '';
    busy = true;
    sendBtn.disabled = true;
    var t = typing();

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: history })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('agent ' + r.status);
        return r.json();
      })
      .then(function (d) {
        var reply = (d && d.reply) || 'Sorry — I could not reach my assistant brain. Please try again.';
        t.remove();
        bubble('agent', linkify(reply));
        history.push({ role: 'assistant', content: reply });
        saveState();
        renderOptions(d && d.options);
        renderProducts(d && d.products);
      })
      .catch(function (err) {
        t.remove();
        bubble('agent', 'Connection issue — please try again in a moment. (' + err.message + ')');
      })
      .then(function () {
        busy = false;
        sendBtn.disabled = false;
        if (!isMobileChat()) input.focus();
      });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    ask(input.value);
  });
})();

/* ── Keep the chat stable on iOS while typing ── */
(function () {
  var chat = document.getElementById('laChat');
  var input = document.getElementById('laInput');
  if (!chat || !input || !window.visualViewport) return;

  function adjust() {
    try {
      if (!chat.classList.contains('open')) return;
      var vv = window.visualViewport;
      var kb = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      document.documentElement.style.setProperty('--la-vh', Math.round(vv.height) + 'px');
      document.documentElement.style.setProperty('--la-kb', Math.round(kb) + 'px');
      if (kb > 40) {
        chat.classList.add('keyboard-up');
        document.body.classList.add('la-keyboard-open');
      } else {
        chat.classList.remove('keyboard-up');
        document.body.classList.remove('la-keyboard-open');
      }
    } catch (e) {}
  }

  window.visualViewport.addEventListener('resize', adjust);
  window.visualViewport.addEventListener('scroll', adjust);
  input.addEventListener('focus', function () { setTimeout(adjust, 120); });
  input.addEventListener('blur', function () { setTimeout(adjust, 120); });
  document.addEventListener('touchend', function (e) {
    if (chat.contains(e.target)) setTimeout(adjust, 150);
  });
})();
